import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=0a6488d2&scoped=true&"
import script from "./configDialog.vue?vue&type=script&lang=js&"
export * from "./configDialog.vue?vue&type=script&lang=js&"
import style0 from "./configDialog.vue?vue&type=style&index=0&id=0a6488d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6488d2",
  null
  
)

component.options.__file = "configDialog.vue"
export default component.exports